<template>
  <div id="contactsection" class="container">
    <div class="columns is-multiline is-centered is-gapless">
      <div class="column is-5 has-text-centered">
        <div class="cont-desc" data-aos="fade-up" data-aos-once="true" style="margin-bottom:40px;">
          <!-- <h1 class="title" style="margin-bottom:0.8rem;">Contact Us:</h1> -->
          <!-- <h4>
            <a href="mailto:sales@lasting-impressions.com.my" target="_blank">
              sales@lasting-impressions.com.my
            </a>
          </h4> -->
          <ul class="info-list">
            <li class="info">
              <div class="context">phone</div>
              <div class="content" style="text-align:left;">
                (6) 03 7806 1491
              </div>
            </li>
            <li class="info">
              <div class="context">email</div>
              <div class="content" style="text-align:left;">
                <a href="mailto:sales@lasting-impressions.com.my;jonathan@lasting-impressions.com.my" target="_blank">
                  sales@lasting-impressions.com.my
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="column is-5">
        <div class="cont-form" data-aos="fade-up" data-aos-once="true">
          <b-field>
            <b-input value="" placeholder="name" v-model.trim="name" @input="$v.name.$touch()"></b-input>
          </b-field>
          <b-field>
            <b-input value="" placeholder="email" v-model.trim="email" @input="$v.email.$touch()"></b-input>
          </b-field>
          <b-field>
            <b-input value="" placeholder="phone number" v-model.trim="number" @input="$v.number.$touch()"></b-input>
          </b-field>
          <b-field>
            <b-input maxlength="500" type="textarea" placeholder="message" v-model.trim="message" @input="$v.message.$touch()"></b-input>
          </b-field>
          <button class="button is-outlined" :class="{ 'is-loading': loading }" @click="onSend($v)">
            <p>{{ loading ? '&nbsp;' : 'SEND' }}</p>
          </button>
          <p v-if="feedback">{{ feedback }}</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script type="text/javascript">
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import auth from '@/apis/Auth'
export default {
  name: 'contactsection',
  mixins: [validationMixin],
  data: function () {
    return {
      name: '',
      email: '',
      number: '',
      message: '',
      feedback: false,
      loading: false
    }
  },
  mounted: function () {
  },
  methods: {
    onSend: function ($v) {
      var _self = this
      if ($v.$invalid) {
        _self.feedback = 'Please fill in all fields to proceed.'
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
      } else {
        _self.feedback = false
        _self.loading = true
        auth.email(
          _self.name,
          _self.email,
          _self.number,
          _self.message
        )
        .then(data => {
          console.log('email sent')
          console.log(data)
          _self.verified = false
          _self.name = ''
          _self.email = ''
          _self.number = ''
          _self.message = ''
          // _self.$toast.open({
          //   message: 'We will be contacting you via email or phone. Thanks!',
          //   position: 'is-bottom',
          //   type: 'is-success'
          // })
          _self.feedback = 'Email sent. Thanks!'
          _self.loading = false
        })
        .catch(error => {
          console.log('invalid email', error)
          // this.error = error.error
          console.log(error)
          // _self.$toast.open({
          //   duration: 5000,
          //   message: 'Oops. Something went wrong. Please email us directly at sales@lasting-impressions.com.my',
          //   position: 'is-bottom',
          //   type: 'is-warning'
          // })
          _self.feedback = 'Oops. Something went wrong. Please email us directly at sales@lasting-impressions.com.my'
          _self.loading = false
        })
      }
    }
  },
  validations: {
    email: {
      required,
      email
    },
    name: {
      required
    },
    number: {
      required
    },
    message: {
      required
    }
  }
}
</script>

<style lang="scss">
@import "../assets/app_setting.scss";

#contactsection {
  // padding: 1rem 0;

  & .cont-desc {
    // margin-top: 1.2rem;
    padding: 0rem 0.75rem;

    @media screen and (min-width: $tablet) {
      margin-top: 2.8rem;
    }

    @media screen and (min-width: $desktop) {
      margin-top: 1.2rem;
    }
  }

  & .cont-form {
    margin-top: 1rem;
    padding: 1rem 0.75rem;

    @media screen and (min-width: $desktop) {
      padding: 0;
    }
    .field {
      padding-bottom: 0.5rem;
    }

    &>p {
      // for feedback field only
      margin-top: 1rem;
      padding: 0.5rem;
      padding-left: 0;
      color: $color-gold;
      text-align: center;
      font-weight: bold;
      @media screen and (min-width: $desktop) {
        text-align: left;
      }
    }

    span {
      display: block;
    }
    input, textarea {
      border: 0;
      box-shadow: none;
      background: transparent;
      border-bottom: 1px solid #bbbbbb;
      &::placeholder {
        color: #999999;
      }
    }

    button {
      border-radius: 0;
      border: 2px solid $color-gold;
      color: $color-gold;
      font-weight: bold;
      background-color: transparent;
      width: 100%;
      height: auto;
      padding-top: 12px;
      padding-bottom: 12px;
      -webkit-transition: all 0.2s ease-in-out 0s;
      transition: all 0.2s ease-in-out 0s;
      opacity: 1;
      flex-direction: column;

      &:after {
        border-color: $color-gold;
        border-right-color: transparent;
        border-top-color: transparent;
      }

      @media screen and (min-width: $desktop) {
        width: 150px;
        // height: auto;
        // padding-top: 12px;
        // padding-bottom: 12px;
      }

      & p {
        color: $color-gray;
      }

      &:hover {
        background-color: $color-gold;
        -webkit-transition: all 0.2s ease-in-out 0s;
        transition: all 0.2s ease-in-out 0s;
        & p {
          color: #fff;
        }
      }
    }
  }

  .info-list {
    .info {
      margin-top: 15px;

      .context {
        border-right: 1px solid #c4c6c6;
        padding-bottom: 12px;
        padding-right: 4%;
        text-align: right;
        width: 25%;
        margin-right: 2.6%;
        display: inline-block;
        vertical-align: top;
      }

      .content {
        width: 70%;
        display: inline-block;
        vertical-align: top;

        &, p {
          color: $color-gray;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ContactSection.vue?06d5c314